import { render, staticRenderFns } from "./otherGroups.vue?vue&type=template&id=02bc074c&scoped=true&lang=html&"
import script from "./otherGroups.vue?vue&type=script&lang=js&"
export * from "./otherGroups.vue?vue&type=script&lang=js&"
import style0 from "./otherGroups.vue?vue&type=style&index=0&id=02bc074c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc074c",
  null
  
)

export default component.exports